import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { StatsSection } from '../common/stats-section';
import { useCareerAndSeasonStatsNavSync } from './hooks/use-career-and-season-stats-nav-sync';
import {
    CategoryNavItem,
    SeasonNavItem
} from './components/nav-items';
import { CareerAndSeasonStatsTable } from './components/table';
import { useCompetitionNavigationOptions } from '../../../../../../common/react/hooks/use-competition-navigation-options';
import {
    careerAndSeasonStatsBenchmarkingSelector,
    careerAndSeasonStatsDataTypeSelector,
    careerAndSeasonStatsNavSelector
} from '../../../../store/js/modules/statspro/career-and-season-stats/selectors';
import {
    BenchmarkingLegend,
    BenchmarkingExplainer
} from '../../../../../../common/react/components/benchmarking';
import {
    BenchmarkingSwitch,
    DataTypeToggle,
    Heading
} from './components/header';

export const CareerAndSeasonStats = ( { title } ) => {
    const benchmarking = useSelector( careerAndSeasonStatsBenchmarkingSelector );
    const nav = useSelector( careerAndSeasonStatsNavSelector );
    const dataType = useSelector( careerAndSeasonStatsDataTypeSelector );
    const options = useCompetitionNavigationOptions( nav );
    useCareerAndSeasonStatsNavSync( options );

    return (
        <StatsSection.Main>
            <StatsSection.Heading isSmallModifier={ true }>
                { title }
            </StatsSection.Heading>
            <StatsSection.Nav>
                <StatsSection.NavItems>
                    <CategoryNavItem />
                    <SeasonNavItem />
                </StatsSection.NavItems>
            </StatsSection.Nav>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading>
                        <Heading />
                    </StatsSection.ContentHeaderHeading>
                    { nav.season.id === -1 &&
                        <StatsSection.ContentHeaderOptions>
                            { ( dataType.type === 'averages' || dataType.type === 'benchmarkedAverages' ) &&
                                <BenchmarkingSwitch />
                            }
                            <DataTypeToggle />
                        </StatsSection.ContentHeaderOptions>
                    }
                    <StatsSection.ContentHeaderBelow>
                        { benchmarking?.isActive &&
                            <BenchmarkingLegend />
                        }
                        { benchmarking?.isActive &&
                            <BenchmarkingExplainer />
                        }
                    </StatsSection.ContentHeaderBelow>
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    <CareerAndSeasonStatsTable />
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};

CareerAndSeasonStats.propTypes = {
    title: PropTypes.string.isRequired
};